module.exports = __webpack_public_path__ + "539f4192b9a342edbde961940abf4d9f.jpg";